module.exports = __webpack_public_path__ + "img/pantalla 6-8.2a580ee2.svg";